import { type FC } from 'react';

import { Text } from '@livechat/design-system-react-components';
import Markdown from 'react-markdown';

import { CopilotLinkWithTooltip } from './CopilotLinkWithTooltip';

import * as styles from './styles';

interface Props {
  text: string;
}

export const CopilotAgentMessage: FC<Props> = ({ text }) => (
  <Text className={styles.popoverAgentMessage}>
    <Markdown
      className={styles.markdown}
      components={{
        a: ({ children, href }) => <CopilotLinkWithTooltip href={href}>{children}</CopilotLinkWithTooltip>,
      }}
    >
      {text}
    </Markdown>
  </Text>
);
